<template lang="pug">
#enterpriseDeptDoc
  recycle(v-if="fileId==='recycle'" :type="4")
  template(v-else)
    operations(ref="operations" :folderId="fileId" :folderPermissions="folderPermissions" @pf="parent" )
    navAndSearch(ref="navAndSearch")
    fileTable(ref="fileTable"  :folderPermissions="folderPermissions" )
</template>

<script>
import navAndSearch from "@/CommonDP/components/documentRelevant/returnLevel.vue";
import fileTable from "./fileTable/fileTable.vue";
import operations from "./operations/operations.vue";
import recycle from "@/CommonDP/pages/components/recycle/index.vue";
import secondaryMenuService from "@/CommonDP/service/secondaryMenu-service";
import { mapState } from "vuex";
import { UserIdentity } from "@/CommonDP/pages/mainMg/doc/common.js";
export default {
  components: {
    navAndSearch, fileTable, operations, recycle
  },
  data () {
    return {
      fileId: "",
      folderPermissions: UserIdentity.ISOUT
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    deptParams() {
      return {
        folderId: "0",
        isRead: 1,
        priviAll: "1",
        enterpriseId: this.enterpriseId,
        type: "",
        versionId: ""
      };
    }
  },
  watch: {
    $route: {
      // 亲测有效,我是用来监听query参数变化
      handler() {
        const { fileId = "" } = this.$route.query;
        if (fileId) {
          this.queryManager();
        }
      },
      immediate: true,
      deep: true
    }
  },
  // 离开路由之前执行的函数
  beforeRouteLeave(to, from, next) {
    // 等于enterpriseDeptDoc路由依然会加载enterpriseDeptDoc下的第一个children，此时不应该清空
    if (to.path !== "/enterpriseDeptDoc") {
      this.$store.dispatch("perFileUpdateNavDan", []);
    }
    next();
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { fileId = "" } = this.$route.query;
      if (!fileId) {
        this.getAllList();
      } else {
        this.queryManager();
      }
    },
    // url有文件id时，处理
    async queryManager() {
      const { fileId = "", fileName = "未命名" } = this.$route.query;
      this.fileId = fileId;
      const obj = { folderId: fileId, folderName: fileName };
      this.$store.dispatch("perFileUpdateNavDan", [obj]);
      await this.getManager(fileId);
    },
    // 没有文件id时，查询部门文档所有，默认第一个
    async getAllList() {
      const { data = [] } = await secondaryMenuService.queryEnterpriseDept(this.deptParams);
      const item = data[0];
      this.$store.dispatch("perFileUpdateNavDan", [item]);
      await this.getManager(item.folderId);
    },
    async getManager(fileId) {
      const result = await secondaryMenuService.queryEnterpriseDeptManager(this.enterpriseId);
      const isAdmin = result.data.some(({ folderId }) => folderId === fileId);
      if (isAdmin) {
        this.folderPermissions = UserIdentity.ISADIM;
      } else {
        this.folderPermissions = UserIdentity.ISDEPT;
      }
      if (fileId !== "recycle") {
        this.$refs.fileTable.init(fileId);
      }
    },
    parent() {
      this.$refs.fileTable.init();
    }
  }
};
</script>

<style lang="scss" scoped>
#enterpriseDeptDoc{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
